import React, { useMemo, useCallback, useState, useEffect } from "react";
import { connect } from "dvajs";
import { UserState } from "@/types/chat/State";
import styles from "./index.module.less";
import { Button } from "antd";
import { isFocusEnv, FocusSDK } from "@/utils";
import { getAppVersion } from "@/utils/getVersion";
import ImService from "@/server/ImService";

const KEY_CROSS_TEAM_BADGE_TIP = "KEY_CROSS_TEAM_BADGE_TIP";

interface IProps {
  hasNew?: boolean;
  onConfirm?: Function;
  [keys: string]: any;
}

function UserGuideTeamBadge(props: IProps) {
  const { onConfirm, hasNew } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const showNewVersion = useCallback(async () => {
    const isWeb = !isFocusEnv();
    if (isWeb) {
      return false;
    }
    const hasTip = await ImService.getInstance()?.getAppModuleVersion(
      KEY_CROSS_TEAM_BADGE_TIP,
      true
    );
    if (hasTip) {
      return false;
    } else {
      return true;
    }
  }, []);

  useEffect(() => {
    if (!hasNew) {
      setVisible(false);
      return;
    }
    showNewVersion().then((show: boolean) => {
      setVisible(show);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNew]);

  const handleClose = (e: any) => {
    e?.stopPropagation();
    setVisible(false);
    const ver = getAppVersion(FocusSDK);
    ImService.getInstance()?.setAppVersion(ver, KEY_CROSS_TEAM_BADGE_TIP, true);
  };

  const handleConfirm = (e: any) => {
    onConfirm?.();
    handleClose(e);
  };

  return visible ? (
    <div className={styles["notificationBanner-wrap"]}>
      <div className={styles.notificationBanner}>
        <i className={styles["arrow-left"]} />
        <div className={styles.content}>
          <div className={styles.title}>多组织消息提醒已上线</div>
          <div className={styles.description}>蓝色图标为其他组织未读总数（不含当前组织）</div>
          <div className={styles.actions}>
            <Button
              type="link"
              className={`${styles.closeButton} ${styles.btn}`}
              onClick={handleClose}
            >
              关闭
            </Button>
            <Button
              type="default"
              className={`${styles.experienceButton} ${styles.btn}`}
              onClick={handleConfirm}
            >
              立即体验
            </Button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

function mapStateToProps({ user }: { user: UserState }) {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserGuideTeamBadge);
